import { Injectable } from "@angular/core";
import {
  ChannelEnum,
  SettingClient,
  SettingViewModel,
} from "src/domain/client";
import SettingNames from "src/domain/extentions/setting-names";
import { ErrorReporterService } from "./error-reporter.service";

@Injectable({
  providedIn: "root",
})
export class SettingService {
  settings: { [name: string]: string } = {};

  constructor(private errorReporter: ErrorReporterService) {}

  getSettings(): void {
    new SettingClient()
      .setting(ChannelEnum.TBO)
      .then((settings) => this.mapSettings(settings))
      .catch(this.errorReporter.handle);
  }

  getSetting(settingName: string): string {
    return this.settings[settingName];
  }

  //////////

  private mapSettings(settings: SettingViewModel[]): void {
    Object.keys(SettingNames).forEach((key) => {
      const setting = settings.find((_) => _.name === key);
      if (setting?.name) {
        if (setting.value == null) delete this.settings[setting.name];
        else this.settings[setting.name] = setting.value;
      }
    });
  }
}
